var map = {
	"./banhanguytin/8.png": "4446",
	"./cacung/8.png": "90d7",
	"./chuyencan/8.png": "7292",
	"./daigiadataha/8.png": "0db8",
	"./duhanhgia/8.png": "23e4",
	"./thanhsanma/8.png": "4c7b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c4b4";